
import { Mapper } from "../../../../base/utils/mapper";
import { TypeScarPhysiotherapyModel } from "../../../../domain/models/consult/type-scar-physiotherapy.model";
import { TypeScarPhysiotherapyEntity } from "../entities/type-scar-physiotherapy.entity";
export class TypeScarPhysiotherapyImplementationRepositoryMapper extends Mapper<TypeScarPhysiotherapyEntity, TypeScarPhysiotherapyModel>{
            mapFrom(param: TypeScarPhysiotherapyEntity): TypeScarPhysiotherapyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param: TypeScarPhysiotherapyModel): TypeScarPhysiotherapyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }